import React from 'react';
import { useOutletContext } from 'react-router-dom';
import PageWrapper from '../../../Components/Paper/PageWrapper';
import {
  customerSurfaces,
  CUSTOMER_FILTERS,
  CALLED_INDICATOR,
} from '../../../Components/ContactListWrapper/utils/customerSurfaces';
import DateStepper from './DateStepper';

/**
 * The filters the page offers: a customer list's, indicating the calls of the day rather than of
 * the wave period, and without the sub-section a birthday does not belong to.
 */
export const BIRTHDAYS_FILTERS =CUSTOMER_FILTERS.filter(
  ({ key }) =>
    key !== 'lastCallInCurrentMonth' &&
    key !== 'subsectionId' &&
    key !== 'calledInCurrentPeriod'
).concat({
  key: 'called',
  ...CALLED_INDICATOR,
  label: 'DAY_CALLED_INDICATOR',
});

/** The surfaces the page's cog offers, each with the layout checked into the client. */
const BIRTHDAYS_SURFACES = customerSurfaces({ filters: BIRTHDAYS_FILTERS });

const BirthdaysPage = function BirthdaysPage() {
  const props = useOutletContext() || {};

  return (
    <PageWrapper
      sectionSubName={<DateStepper />}
      surfaces={BIRTHDAYS_SURFACES}
      statsTabs={['DAILY', 'MONTHLY']}
      apiType="BirthDay"
      {...props}
    />
  );
};

export default BirthdaysPage;
